import { useState } from 'react'

const useEmbedSetupDrawer = () => {
  const [showEmbedSetupDrawer, setShowEmbedSetupDrawer] = useState(false)

  const handleOpenEmbedSetupDrawer = () => setShowEmbedSetupDrawer(true)
  const handleCloseEmbedSetupDrawer = () => setShowEmbedSetupDrawer(false)

  return { showEmbedSetupDrawer, handleOpenEmbedSetupDrawer, handleCloseEmbedSetupDrawer }
}

export default useEmbedSetupDrawer
